import React, { useState, useEffect } from "react";
import { Layout, Menu } from "antd";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import type { MenuProps } from "antd";

import "./side-admin-menu.scss";
import { ItemType } from "antd/es/menu/hooks/useItems";

interface SubMenuItem {
  id: number;
  title: string;
  path: string;
  parentId: number;
}

interface MenuItem {
  id: number;
  title: string;
  path?: string;
  submenu?: SubMenuItem[];
}

interface SideAdminMenuProps {
  items: MenuItem[];
}

const SideAdminMenu: React.FC<SideAdminMenuProps> = ({ items }) => {
  const { Sider } = Layout;
  const location = useLocation();
  const currentLocation = location ? location.pathname : "";
  const [currentItem, setCurrentItem] = useState<(MenuItem | SubMenuItem)[]>([]);

  const [openKeys, setOpenKeys] = useState<string[]>([]);

  useEffect(() => {
    const matchedItem: (SubMenuItem | MenuItem)[] = [];
    const submenuKeySet = new Set<string>();

    items.forEach((item) => {
      if (item.path) {
        if (currentLocation.startsWith(item.path)) {
          matchedItem.push(item);
        }
      } else {
        item?.submenu?.forEach((value) => {
          if (value.path === currentLocation) {
            matchedItem.push(value);
          }
          submenuKeySet.add(value.parentId.toString());
        });
      }
    });

    setCurrentItem(matchedItem);
    setOpenKeys(Array.from(submenuKeySet));
  }, [items, currentLocation]);


  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: ItemType[],
    type?: 'group'
  ): ItemType {
    const item: ItemType = {
      key,
      icon,
      children,
      label,

      ...(type && { type }),
    } as ItemType;

    return item;
  }

  const menuItems: ItemType[] = items.length > 0
    ? items.map((item) => {
      if (item?.submenu) {
        return getItem(
          item.title,
          item.id,
          undefined,
          item.submenu.map((sub) =>
            getItem(<Link to={sub.path}>{sub.title}</Link>, sub.id)
          )
        );
      } else {
        return getItem(<Link to={item.path!}>{item.title}</Link>, item.id);
      }
    })
    : [];


  const handleChangeSubMenu = (keys: string[]) => {
    setOpenKeys(keys);
  };

  return currentItem.length ? (
    <Sider theme="light" className="aside-admin-menu">
      <Menu
        mode="inline"
        selectedKeys={[currentItem[0]?.id?.toString() || ""]}
        openKeys={openKeys}
        onOpenChange={handleChangeSubMenu}
        items={menuItems}
      />
    </Sider>
  ) : (null);
};

export default SideAdminMenu;
